module.exports = __webpack_public_path__ + "media/חללית.ec5e5bc8.mp3";